const RFR26_MODULE = 'RFR26';
const RFR26_VALID_CODE_POSTAL = '83520';
const RFR26_RESTRICTION_END = '2026-09-14';
const SESSION_KEY = 'rfr26_code_postal_validated';

export function isRFR26RestrictionActive(moduleBase) {
    if (moduleBase !== RFR26_MODULE) {
        return false;
    }
    return new Date() < new Date(`${RFR26_RESTRICTION_END}T00:00:00`);
}

export function isRFR26CodePostalValidated() {
    return sessionStorage.getItem(SESSION_KEY) === '1';
}

export function setRFR26CodePostalValidated() {
    sessionStorage.setItem(SESSION_KEY, '1');
}

export function validateRFR26CodePostal(codePostal) {
    return String(codePostal).trim() === RFR26_VALID_CODE_POSTAL;
}

export function shouldBypassRFR26Check(mainStore) {
    return mainStore.view_as_admin

        || mainStore.is_inscription_vip;
}

export function requiresRFR26CodePostalCheck(mainStore) {
    if (!isRFR26RestrictionActive(mainStore.module.base)) {
        return false;
    }

    if (isRFR26CodePostalValidated()) {
        return false;
    }
    return true;
}
